import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './init';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Overlay from './Components/Overlay/Overlay';
import TagManager from 'react-gtm-module';
//import './i18n';

const tagManagerArgs = {
  // trevor's test container
  gtmId: 'GTM-NRHHTNL',
};

TagManager.initialize(tagManagerArgs);

// Mobile fix for 100vh.
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

ReactDOM.render(
    <Suspense fallback={<Overlay show={true} />}>
        <App />
    </Suspense>,
    document.getElementById('root')
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
